import Table, { TableProps, TablePaginationConfig } from './Table';
export { ColumnProps } from './Column';
export { ColumnsType, ColumnType, ColumnGroupType } from './interface';
export { TableProps, TablePaginationConfig };
export default Table;
